let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import SVGWrapperBase from '../baseStyledComponents/SVGWrapperBase';
export default styledWithTheme(SVGWrapperBase)(_t || (_t = _`
  font-size: 290%;
  ${0}
`), ({
  src
}) => src ? `background-image: url('${src}');` : '');